import { StarActiveIcon, StarIcon } from 'assets/icons';
import { User } from 'components';
import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { PreparationService } from 'services';
import { Colors, Constants, Globals } from 'utils';

interface Props extends RootState {
  lawyer: any;
  action?: any;
}

class Preparations extends React.Component<Props> {
  state = {
    data: null,
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await PreparationService.getLawyerDetail({
      lawyer_id: this.props.lawyer?.id,
    });

    this.setState({
      data: res.lawyer || null,
    });
  };

  getColor = (item: any) => {
    switch (item) {
      case Constants.PREPARATION_STATUS.PENDING:
        return Colors.orange;
        break;

      case Constants.PREPARATION_STATUS.FINISHED:
        return Colors.gray3;
        break;
    }
  };

  render() {
    const { lawyer } = this.props;
    const data: any = this.state.data;

    return (
      <div id='modal-lawyer'>
        <div className='body'>
          <div className='lawyer'>
            <User image={data?.photo} name={data?.full_name} title='Abogado' />
            <div className='rating'>
              <p>
                {data?.avgRating
                  ? Globals.formatMiles(data?.avgRating, true, '')
                  : 'Sin calificación'}
              </p>
              <img src={StarActiveIcon} />
            </div>
          </div>

          <div className='description'>
            <small>
              {data?.city?.name} - {data?.state?.name}
            </small>
            <p className='area'>{lawyer?.area?.name}</p>

            <p className='document'>{lawyer?.document?.name}</p>
            {/* <p>
                {data?.state_id == this.props.user?.state_id
                  ? '(Incluye delivery de documentos)'
                  : '(No incluye delivery de documentos)'}
              </p> */}

            {lawyer?.lawyer_document_price && (
              <div className='container-total'>
                <div style={{ flex: 1 }}>
                  <p className='note'>Honorarios al abogado (a acordar)</p>
                </div>
                <p className='price'>{lawyer?.lawyer_document_price}$</p>
              </div>
            )}
            {/* Fee de plataforma DESACTIVADO temporalmente: la elaboración documental
                ahora es accesible sin cobro de fee para cualquier usuario.
            {lawyer?.fee && !lawyer?.platform_fee_exempt && (
              <div className='container-total'>
                <div style={{ flex: 1 }}>
                  <p className='note'>Fee de plataforma </p>
                </div>
                <p className='price'>{lawyer?.fee}$</p>
              </div>
            )}
            {lawyer?.platform_fee_exempt && (
              <p className='note'>Este abogado no cobra comisión de plataforma.</p>
            )}
            */}
            <div style={{ display: 'inline-flex' }}>
              {lawyer?.status !== undefined && (
                <div className='status' style={{ backgroundColor: this.getColor(lawyer?.status) }}>
                  <small>{lawyer?.status_text}</small>
                </div>
              )}
            </div>

            {(data?.bank_data?.payment_mobile_bank || data?.bank_data?.transfer_bank) && (
              <div>
                <p className='note' style={{ marginTop: '10px' }}>
                  Datos bancarios del abogado:
                </p>
              </div>
            )}

            {data?.bank_data?.payment_mobile_bank && (
              <div>
                <div className='text-right'>
                  <h6>Pago Móvil</h6>
                </div>
                <p className='data-pay'>Banco: {data?.bank_data?.payment_mobile_bank?.name}</p>
                <p className='data-pay'>
                  Teléfono: {data?.bank_data?.payment_mobile_phonecode?.name}
                  {data?.bank_data?.payment_mobile_phone}
                </p>
                <p className='data-pay'>
                  Cédula o RIF: {data?.bank_data?.payment_mobile_document_type?.name}
                  {data?.bank_data?.payment_mobile_document}
                </p>
              </div>
            )}

            {data?.bank_data?.transfer_bank && (
              <div>
                <div className='text-right'>
                  <h6>Transferencia</h6>
                </div>
                <p className='data-pay'>Banco: {data?.bank_data?.transfer_bank?.name}</p>
                <p className='data-pay'>Número de cuenta: {data?.bank_data?.transfer_account}</p>
                <p className='data-pay'>Tipo de cuenta: {data?.bank_data?.transfer_type_text}</p>
                <p className='data-pay'>
                  Cédula o RIF: {data?.bank_data?.transfer_document_type?.name}
                  {data?.bank_data?.transfer_document}
                </p>
              </div>
            )}

            <p className='text'>
              Nota: El precio del trabajo lo define el abogado y se acuerda directamente con él,
              fuera de la plataforma.
            </p>
          </div>
        </div>

        <div className='specialities'>
          <div className='header'>
            <p>Especialidad</p>
          </div>
          {data?.user_areas?.map((item: any) => {
            return (
              <div className='item'>
                <p>{item?.area?.name}</p>
              </div>
            );
          })}
        </div>

        {data?.biography && (
          <div className='info'>
            <p className='subtitle'>Biografía</p>
            <p className='biography'>{data?.biography}</p>
          </div>
        )}

        {data?.experience_text && (
          <div className='info'>
            <p className='subtitle'>Experiencia</p>
            <p>{data?.experience_text}</p>
          </div>
        )}

        {this.props.action && (
          <button className='btn' onClick={this.props.action}>
            Adquirir
          </button>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Preparations);
